var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"fill":"none","height":"12","viewBox":"0 0 24 12","width":"24","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M12 1L2 11H22L12 1Z","fill":"white","stroke":"#E0E6ED"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }